export const enum EnumPedidoPagamentoSituacao {
    APROVADO = 1,
    CANCELADO = 2,
    ADIANTADO = 3,
}